import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  // {
  //   path: '/',
  //   name: 'home',
  //   component: Home,
  // },
  {
    path: '/',
    redirect: '/survey',
  },
  {
    path: '/login',
    name: 'login',
    component: () =>
      import(/* webpackChunkName: "auth" */ '../views/auth/Login.vue'),
  },
  {
    path: '/register',
    name: 'register',
    component: () =>
      import(/* webpackChunkName: "auth" */ '../views/auth/Register.vue'),
  },
  {
    path: '/auth/redirect',
    name: 'auth-redirect',
    component: () =>
      import(/* webpackChunkName: "auth" */ '../views/auth/Redirect.vue'),
  },
  {
    path: '/reporting',
    name: 'reporting',
    meta: { auth: true },
    children: [
      {
        path: '/census-report',
        name: 'census-report',
        component: () =>
          import(
            /* webpackChunkName: "reporting" */ '../views/reporting/CensusReport.vue'
          ),
      },
    ],
    component: () =>
      import(
        /* webpackChunkName: "reporting" */ '../views/reporting/Index.vue'
      ),
  },
  {
    path: '/survey',
    children: [
      {
        path: '/',
        name: 'survey',
        component: () =>
          import(/* webpackChunkName: "survey" */ '../views/survey/Login.vue'),
      },
      {
        path: '/question/:id?',
        name: 'survey-question',
        component: () =>
          import(
            /* webpackChunkName: "survey" */ '../views/survey/Question.vue'
          ),
      },
    ],
    component: () =>
      import(/* webpackChunkName: "survey" */ '../views/survey/Index.vue'),
  },
  {
    path: '/thank-you/:type?',
    name: 'thank-you',
    component: () =>
      import(/* webpackChunkName: "survey" */ '../views/survey/ThankYou.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const loggedIn = localStorage.getItem('user');

  if (to.matched.some(record => record.meta.auth) && !loggedIn) {
    next({ name: 'login' });

    return;
  }

  next();
});

router.beforeEach((to, from, next) => {
  let isDelegated = false;

  for (let matched = to.matched || [], i = matched.length; i--; ) {
    const route = matched[i];

    if (route.beforeEnter) {
      isDelegated = true;
      route.beforeEnter(to, from, next);
    }
  }

  !isDelegated && next();
});

export default router;
